import React, { useEffect } from 'react';
import { View, Animated } from 'react-native';
import { connect } from 'react-redux';
import styles from './styles';
import get from 'lodash/get';
import { removePopup } from '../../actions/showPopover';
import { Typography, useTheme } from '@hmsexp/component-library';
import { IntlProvider } from 'react-intl';
import getSelectedLocale from '../../selectors/getSelectedLocale';
import Translations from '../../Translations/en.json';
import DismissButton from './DismissButton';
import getDeviceType from '../../utils/getDeviceType';
import NotificationStatus from './NotificationStatus';
import notificationBackGroundColor from './getBgColor';
import { isSmallDevice } from '../../utils/isSmallDevice';

const Popover = props => {
  const { popupList, removePopup, locale, showDismiss = false } = props;
  const theme = useTheme();
  const { isMobileBrowser } = getDeviceType();
  const timerMap = {};
  const toastOpacity = new Animated.Value(0);
  const isMobile = isSmallDevice(theme);

  useEffect(() => {
    if (popupList.length > 0) {
      for (let itr = 0; itr < popupList.length; itr++) {
        const popupDisplayTime = popupList[itr].timer || 400;
        if (!timerMap[popupList[itr].id]) {
          timerMap[popupList[itr].id] = setTimeout(() => {
            removePopup({ id: popupList[itr].id });
          }, popupDisplayTime);
        }
      }

      Animated.timing(toastOpacity, {
        toValue: 1,
        duration: 130,
        useNativeDriver: false
      }).start();
      return function () {
        Object.keys(timerMap).forEach(item => {
          clearTimeout(timerMap[item]);
        });
      };
    }
  }, [popupList]);

  const renderPopover = ({ item }) => {
    const onRequestClose = () => {
      removePopup({ id: item.id });
    };

    return (
      <View
        key={item.id}
        style={[
          styles.popoverMessageWrapper,
          {
            backgroundColor: notificationBackGroundColor({ item, palette: theme.palette })
          }
        ]}>
        <View style={styles.popoverLeftChild}>
          <NotificationStatus item={item} />
          <View style={styles.popovertext}>
            <Typography
              color='white'
              variant='subtitle2'
              fontWeightType='regular'
              textProps={{
                numberOfLines: 2,
                ellipsizeMode: 'tail'
              }}>
              {get(item, 'toast_text', '')}
            </Typography>
          </View>
        </View>
        {showDismiss ? (
          <View>
            <DismissButton onRequestClose={onRequestClose} />
          </View>
        ) : null}
      </View>
    );
  };

  if (popupList.length > 0) {
    return (
      <IntlProvider locale={locale} messages={Translations}>
        <View style={styles.body}>
          <Animated.View
            style={[
              styles.container,
              { bottom: isMobileBrowser ? 150 : 25, opacity: toastOpacity },
              !isMobile && styles.webPositionContainer
            ]}>
            {popupList.map(item => renderPopover({ item }))}
          </Animated.View>
        </View>
      </IntlProvider>
    );
  } else return null;
};

const mapStateToProps = state => ({
  popupList: state.popupReducer.popupList,
  locale: getSelectedLocale(state)
});

const mapDispatchToProps = {
  removePopup
};

export default connect(mapStateToProps, mapDispatchToProps)(Popover);
